import { useMemo, useState } from "react";
import { recommendTags, recommendations } from "@/mocks/siteContent";

export default function RecommendSection() {
  const [activeTag, setActiveTag] = useState("全部");

  const list = useMemo(
    () =>
      activeTag === "全部"
        ? recommendations
        : recommendations.filter((item) => item.tags.includes(activeTag)),
    [activeTag]
  );

  return (
    <section id="recommend" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-4">
            <i className="ri-heart-3-line" aria-hidden="true"></i>
            类似推荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            按口味挑，不用自己一部部翻找
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            确定自己偏爱哪一类之后，直接用下方标签筛选。筛选只作用于本页已经展示的内容，点一下即可即时更新。
          </p>
        </div>

        <div role="tablist" aria-label="口味标签筛选" className="mt-8 flex flex-wrap gap-2">
          {recommendTags.map((tag) => {
            const isActive = activeTag === tag;
            return (
              <button
                key={tag}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActiveTag(tag)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors border ${
                  isActive
                    ? "bg-primary-500 text-background-50 border-primary-500"
                    : "bg-background-100 text-foreground-700 border-background-200/70 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>

        <p className="mt-4 text-xs text-foreground-500" aria-live="polite">
          当前显示 {list.length} 条推荐
        </p>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((item) => (
            <article
              key={item.title}
              className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden flex flex-col transition-colors hover:border-accent-300"
            >
              <div className="w-full h-40 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`${item.title} 推荐配图`}
                  title={`${item.title} 类似推荐`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span key={tag} className="px-2.5 py-1 rounded-full text-xs bg-accent-100 text-accent-800">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{item.reason}</p>
                <div className="mt-4 pt-3 border-t border-background-200/70 flex items-center gap-2 text-xs text-secondary-700">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {item.scene}
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-8 text-center text-sm text-foreground-500">该口味下暂时没有条目，试试其他标签。</p>
        )}
      </div>
    </section>
  );
}